import {BrowserRouter, Routes, Route} from "react-router-dom";
import Home from "./pages/Home";
import BigCommerceDashboard from "./pages/Dashboard";
import ConfigManagement from "./pages/ConfigManagement";
import {AppConfigProvider} from "./context/AppConfigContext";
import TrackingPage from "./pages/TrackingPage";

export default function App() {
    return (
        <AppConfigProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/dropship/tracking/:orderId" element={<TrackingPage/>}/>
                    <Route path="/config-add" element={<Home/>}/>
                    <Route path="/auth/load" element={<BigCommerceDashboard/>}/>
                    <Route path="/config-edit" element={<ConfigManagement/>}/>
                </Routes>
            </BrowserRouter>
          </AppConfigProvider>
    );
}
